import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Container, Box, Center, Spinner } from "@chakra-ui/react";
import CommonHeader from "../FormCreation/Header";
import FormList from "./FormList";
import { getTemplate as getPreviewTemplate } from "../../api/shortcodeTemplateApi";
import { getTemplates,deleteTemplates } from "../../api/templateApi";
import { defaultTemplates } from "../ChooseTemplate/defaultTemplates.json";
import ModalFormPreview from "../Common/ModalFormPreview";
import FormPreview from "../FormPreview";
import { IoNuclearOutline } from "react-icons/io5";

const FormListPage = ({
  currentTemplate,
  isTemplateDeleted
}) => {
  const [templates, setTemplates] = useState(IoNuclearOutline);
  const [previewMode, setPreviewMode] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [previewTemplateId, setPreviewTemplateId] = useState(null);
  const [redirectChooseTemplate, setRedirectChooseTemplate] = useState(null);
  const [allChecked, setAllChecked] = useState(false);
  const [isChecked, setIsChecked] = useState({});
  const [selectValue, setSelectValue] = useState("");
  const data = {};
  templates.length && templates.map(({ id }) => (data[id] = false));
  const [formData, setFormData] = useState([]);
  const [deleteList, setDeleteList] = useState([]);
  const [shouldDelete, setShouldDelete] = useState(false);
  
  const onClickPreviewHandler = (id) => {
    setPreviewMode(true);
    setPreviewTemplateId(id);
  };

  const addFormHandler = (e) => {
    e.preventDefault();
    setRedirectChooseTemplate(true);
  };

  const handlePreviewModeClose = (onClose) => {
    setPreviewMode((isToggled) => !isToggled);
    setPreviewTemplate(() => null);
    onClose();
  };

  const onChangeCheckBox = (e, id) => {
    const checkedValue = e.target.checked;
    id != "mainCheckBox" && setIsChecked({ ...isChecked, [id]: checkedValue });
    if (id == "mainCheckBox") {
      for (const key in data) {
        data[key] = e.target.checked;
      }
      setAllChecked(e.target.checked), setFormData(data);
    }
  };

  const onChangeEvent = (e) => {
    setSelectValue(e.target.value);
  };

  const onClickEvent = () => {
    const makeDeleteList = allChecked ? formData : isChecked;
    const deleteListIds = [];
    for (const list in makeDeleteList) {
      makeDeleteList[list] && deleteListIds.push(list);
    }
    setDeleteList(deleteListIds);
    if (deleteListIds.length && selectValue == "delete")
    setShouldDelete(true);
  };

  useEffect(() => {
    if (shouldDelete) {
      deleteTemplates(deleteList)
        .then((data) => {
         console.log("data",data);
          let new_submissions = Object.values(data);
          setTemplates(new_submissions);
          setShouldDelete(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [shouldDelete]);

  useEffect(() => {
    const apiUrl = `http://localhost/wordpress/wp-json`;
    const nonce = `5c74968270`;
    if (previewMode) {
      getPreviewTemplate(previewTemplateId,  window.appLocalizer) //{ apiUrl, nonce } window.appLocalizer
        .then((template) => {
          console.log("useEffect-->>",template);
          setPreviewTemplate(() => ({ ...template }));
        })
        .catch((err) => {
          if (previewTemplateId.includes("default")) {
            const template = defaultTemplates.find(
              (template) => previewTemplateId == template.id
            );
            setPreviewTemplate(() => ({ ...template }));
          }
          throw err;
        });
    }
  }, [previewMode]);

  useEffect(() => {
    if (isTemplateDeleted || !templates.length)
      getTemplates().then((response) => {
        console.log("response==>",response)
        response =
          response instanceof Array ? response : Object.values(response);
        setTemplates(response);
      });
  }, [isTemplateDeleted]);

  const renderPreviewForm = () => {
    if (previewMode && !previewTemplate) {
      return (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      );
    }
    return previewMode && previewTemplate ? (
      <ModalFormPreview
        shouldOpen={previewMode}
        handlePreviewModeClose={handlePreviewModeClose}
      >
        <FormPreview template={previewTemplate} />
      </ModalFormPreview>
    ) : null;
  };
  return (
    <Container w="100%" h="100vh" maxW="100%" p="0" bg="#F0F0F1">
      {!templates && (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      )}
      {renderPreviewForm()}
      {redirectChooseTemplate && <Redirect to="choose-template" />}
      {currentTemplate && currentTemplate.id && <Redirect to="dashboard" />}
      <CommonHeader handleOnClick={addFormHandler} />
      <Box p="1rem">
        {/* <Header /> */}
        <FormList
          templates={templates}
          allChecked={allChecked}
          isChecked={isChecked}
          selectValue={selectValue}
          onChangeEvent={onChangeEvent}
          onClickEvent={onClickEvent}
          onClickPreviewHandler={onClickPreviewHandler}
          onChangeCheckBox={onChangeCheckBox}
        />
        {/* <Footer /> */}
      </Box>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    currentTemplate: state.templates.currentTemplate,
    isTemplateDeleted: state.templates.deleted,
  };
};

export default connect(mapStateToProps, null)(FormListPage);
